import React, { Component } from 'react';
import mobileVerify from '../../verification/mobile-verify.js';

class AccountSettingsMobileEnterCode extends Component {
	componentWillMount() {
		mobileVerify().open('verify_code');
	}

	render() {
		return (
			<div id="account-verify-mobile-enter-code" />
		);
	}
}

export default AccountSettingsMobileEnterCode;




// WEBPACK FOOTER //
// ./mobile-core/src/components/account/account-settings-mobile-enter-code.js